import React from "react";

const CreateWorkOut = React.lazy(() => import("./CreateWorkOut"));
const Index = React.lazy(() => import("./index"));
const Workouts = React.lazy(() => import("../../components/Workouts"));
const WorkoutDetails = React.lazy(() => import("./WorkoutDetails"));

export const workoutRoutes = [
  {
    path: "/admin/workOut",
    name: "Workouts",
    element: <Workouts />,
  },
  {
    path: "/admin/workOut/create",
    name: "Create workouts",
    element: <CreateWorkOut />,
  },
  {
    path: "/admin/workOut/update/:id?",
    name: "Create workouts",
    element: <CreateWorkOut />,
  },
  {
    path: "/admin/workOut/:id",
    name: "Workout",
    element: <WorkoutDetails />,
  },
];
